import { Capacitor } from "@capacitor/core";
import posthog from "posthog-js";
import { env } from "@/env";
import { debugValue } from "@/env/utils";

if (env.VITE_POSTHOG_KEY) {
  // Use full URL for mobile apps, relay path for web
  const apiHost = Capacitor.isNativePlatform()
    ? env.VITE_POSTHOG_HOST
    : env.VITE_POSTHOG_HOST?.startsWith("http")
      ? env.VITE_POSTHOG_HOST
      : "/relay-i8gJ";

  posthog.init(env.VITE_POSTHOG_KEY, {
    api_host: apiHost,
    person_profiles: "always",
    persistence: "localStorage",
    debug: debugValue("posthog"),
    capture_pageview: false,
    capture_pageleave: true,
    enable_recording_console_log: true,
    enable_heatmaps: true,
    disable_web_experiments: false,
    session_recording: {
      maskAllInputs: true,
      maskTextSelector: "[data-ph-no-capture]",
    },
    sanitize_properties: (properties) => {
      if (properties["$current_url"]) {
        properties["$current_url"] = maskedSensitiveParams(properties["$current_url"]);
      }
      return properties;
    },
  });
}

export * from "posthog-js";

function maskedSensitiveParams(url: string) {
  // Short circuit if no params are detected
  if (url.indexOf("?") === -1) {
    return url;
  }

  const queryString = url.split("?")[1];
  const searchParams = new URLSearchParams(queryString);

  // Sensitive parameters to be hidden
  const sensitiveParams = ["accessToken", "refreshToken", "verificationCode", "email"];

  // Replace each sensitive parameter's value with '{hidden}'
  sensitiveParams.forEach((param) => {
    if (searchParams.has(param)) {
      searchParams.set(param, "{hidden}");
    }
  });

  // Combine the base URL with the modified query string
  return url.split("?")[0] + "?" + searchParams.toString();
}
